/** Phase 5K — Merchant programme exit audit + tablet alert bindings (07-02) */

import { KITCHEN_DISPLAY_SCREEN_IDS } from '../kitchen-display/catalog.js';
import { ORDER_BOARD_SCREEN_IDS } from '../order-board/catalog.js';

export const MERCHANT_PROGRAMME_SCREEN_COUNT = 90;

export const MERCHANT_SCREEN_IDS = Array.from(
  { length: MERCHANT_PROGRAMME_SCREEN_COUNT },
  (_, index) => {
    return `SCR-MER-${String(index + 1).padStart(3, '0')}`;
  },
) as readonly string[];

export type MerchantScreenId = `SCR-MER-${string}`;

/** Tablet fleet surfaces that subscribe to merchant realtime alerts */
export const TABLET_ALERT_SCREEN_IDS = [
  ...ORDER_BOARD_SCREEN_IDS,
  ...KITCHEN_DISPLAY_SCREEN_IDS,
] as const;

export type TabletAlertScreenId = (typeof TABLET_ALERT_SCREEN_IDS)[number];

export const MERCHANT_EXIT_ENDPOINTS = {
  realtime: ['POST /merchant/v1/realtime/connection-tickets'],
  settings: ['GET /merchant/v1/settings', 'PATCH /merchant/v1/settings'],
} as const;

export const TABLET_ALERT_CHANNELS = [
  {
    id: 'order_board',
    label: 'Order board alerts',
    screenIds: ORDER_BOARD_SCREEN_IDS,
    realtimeTopic: 'merchant.order-board',
  },
  {
    id: 'kitchen_display',
    label: 'Kitchen display alerts',
    screenIds: KITCHEN_DISPLAY_SCREEN_IDS,
    realtimeTopic: 'merchant.kitchen-display',
  },
] as const;
